import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52024a27"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main",
  class: "MainLayout-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_component_MainMenu)
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_DxScrollView, {
        width: "100%",
        height: "99%",
        disabled: _ctx.scrollDisabledValue
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, "© Opti-Soft " + _toDisplayString(new Date().getFullYear()), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, "Дата и время сервера: " + _toDisplayString(_ctx.serverTime), 1)
      ])
    ])
  ]))
}